import React, { useEffect, useState } from "react";

function EditorialFilters({
  categories,
  currentCategory,
  query,
  resultCount,
  onCategoryChange,
  onSearch,
}) {
  const [searchValue, setSearchValue] = useState(query);

  useEffect(() => {
    setSearchValue(query);
  }, [query]);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch(searchValue.trim());
  };

  const clearFilters = () => {
    setSearchValue("");
    onSearch("", "all");
  };

  return (
    <div className="editorial-filters" aria-label="Filter editorial stories">
      <div className="editorial-filters__categories" role="group" aria-label="Categories">
        {["all", ...categories].map((category) => {
          const isAll = category === "all";
          const isActive = currentCategory === category;

          return (
            <button
              className={isActive ? "is-active" : undefined}
              key={category}
              type="button"
              aria-pressed={isActive}
              onClick={() => onCategoryChange(category)}
            >
              {isAll ? "All" : category}
            </button>
          );
        })}
      </div>

      <form className="editorial-filters__search" role="search" onSubmit={handleSubmit}>
        <label htmlFor="editorial-search">Search this collection</label>
        <div>
          <input
            id="editorial-search"
            type="search"
            value={searchValue}
            onChange={(event) => setSearchValue(event.target.value)}
            placeholder="Try tomato, pasta, or giving"
          />
          <button type="submit">Search</button>
        </div>
      </form>

      <div className="editorial-filters__status">
        <p aria-live="polite">
          {resultCount} {resultCount === 1 ? "story" : "stories"}
        </p>
        {(currentCategory !== "all" || query) && (
          <button type="button" onClick={clearFilters}>
            Clear filters
          </button>
        )}
      </div>
    </div>
  );
}

export default EditorialFilters;
